import {
  ButtonGroup,
  closeCurrentDialog,
  DataStatus,
  DialogFooter,
  NotificationItem,
  NotificationItemData,
  showNotification,
} from 'platform/components';
import {Show} from 'platform/foundation';

import {useEffect, useState} from 'react';

import {isNil} from 'ramda';

import {useGetToastNotificationExampleQuery} from '@dms/api/core';
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';
import i18n from '@dms/i18n';
import {useGetNotificationItemData} from '@dms/notifications';

import {useBoolean} from 'shared/web';

interface NotificationPreviewProps {
  notificationId: string;
}

export function NotificationExamplePreview(props: NotificationPreviewProps) {
  const {data: notification, isError} = useGetToastNotificationExampleQuery({
    id: props.notificationId,
  });

  const [isLoading, startLoading, stopLoading] = useBoolean(true);

  const {data: currentUser} = useGetCurrentUserInfoQuery();
  const getNotificationItemData = useGetNotificationItemData();

  const [parsedNotification, setParsedNotification] = useState<NotificationItemData | null>();

  useEffect(
    function loadParsedNotification() {
      if (isNil(currentUser) || isNil(notification)) {
        return;
      }

      startLoading();

      Promise.resolve(getNotificationItemData(notification, currentUser.id)).then((item) => {
        setParsedNotification(item);
        stopLoading();
      });
    },
    [getNotificationItemData, notification, currentUser, startLoading, stopLoading]
  );

  return (
    <DataStatus
      isLoading={isLoading}
      isError={isError}
      isEmpty={isNil(parsedNotification)}
      emptyMessage={i18n.t('page.demo.notificationNotHandled')}
      minHeight={20}
      spacing={3}
    >
      <Show when={parsedNotification}>
        {(parsedNotification) => (
          <NotificationItem
            onNavigate={(url: string) => showNotification.info(`Navigating to: ${url}`)}
            {...parsedNotification}
          />
        )}
      </Show>

      <DialogFooter>
        <ButtonGroup
          align="right"
          buttons={[{title: i18n.t('general.actions.close'), onClick: closeCurrentDialog}]}
        />
      </DialogFooter>
    </DataStatus>
  );
}
